// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.claims.RentalManagerUserClaimV2WebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserClaimV2WebApiHandler_add,
  RentalManagerUserClaimV2WebApiHandler_delete,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  UserClaimAddResponseV2WebDto,
  UserClaimAddV2RequestDto,
  UserClaimDeleteV2RequestDto,
} from '@zg-rentals/ts-rental-manager-api-client';

export interface RentalManagerUserClaimV2WebApiHandler_add_Args {
  postData: UserClaimAddV2RequestDto;
}

export type RentalManagerUserClaimV2WebApiHandler_add_Options = UseMutationOptions<
  UserClaimAddResponseV2WebDto,
  unknown,
  RentalManagerUserClaimV2WebApiHandler_add_Args
>;

/**
 * Add a new contact method
 */
export const useRentalManagerUserClaimV2WebApiHandler_add = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserClaimV2WebApiHandler_add_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserClaimV2WebApiHandler_add_Args) =>
      RentalManagerUserClaimV2WebApiHandler_add(args.postData, httpClient),
  });
};

export interface RentalManagerUserClaimV2WebApiHandler_delete_Args {
  postData: UserClaimDeleteV2RequestDto;
}

export type RentalManagerUserClaimV2WebApiHandler_delete_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserClaimV2WebApiHandler_delete_Args
>;

/**
 * Delete a contact method
 */
export const useRentalManagerUserClaimV2WebApiHandler_delete = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserClaimV2WebApiHandler_delete_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserClaimV2WebApiHandler_delete_Args) =>
      RentalManagerUserClaimV2WebApiHandler_delete(args.postData, httpClient),
  });
};
